import * as React from "react";
import useProductName from "brand-customization/useProductName";
import { Trans, useTranslation } from "react-i18next";
import { Alert } from "components/bootstrap";
import { StyledHeading, DescriptionCol } from "components/inputs/InputSetupWizard";
import IlluminateList from "./IlluminateList";
import { ILLUMINATE_PACK_TYPES } from "../SelectIlluminateStep";
const SelectProcessingPacks = ({
  selectedProcessingPacks,
  setSelectedProcessingPacks,
  isLoadingProcessingPacks,
  processingPacksData,
  setTouched
}) => {
  const { t } = useTranslation("enterprise_forwarder");
  const productName = useProductName();
  const illuminateInfoText = t("select_processing_packs.info_text", { productName });
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledHeading, null, t("select_processing_packs.heading")), /* @__PURE__ */ React.createElement(DescriptionCol, null, processingPacksData.length > 0 ? /* @__PURE__ */ React.createElement(React.Fragment, null, " ", /* @__PURE__ */ React.createElement("p", null, t("select_processing_packs.select_intro"), /* @__PURE__ */ React.createElement("br", null), illuminateInfoText), /* @__PURE__ */ React.createElement("p", null, t("select_processing_packs.enabled_hint"))) : /* @__PURE__ */ React.createElement("p", null, " ", illuminateInfoText)), /* @__PURE__ */ React.createElement(Alert, { bsStyle: "info" }, /* @__PURE__ */ React.createElement(Trans, { t, i18nKey: "select_processing_packs.skip_alert", components: { em: /* @__PURE__ */ React.createElement("em", null) } })), /* @__PURE__ */ React.createElement(
    IlluminateList,
    {
      isLoading: isLoadingProcessingPacks,
      listData: processingPacksData,
      selectedPacks: selectedProcessingPacks,
      setSelectedPacks: setSelectedProcessingPacks,
      setTouched,
      type: ILLUMINATE_PACK_TYPES.PROCESSING
    }
  ));
};
export default SelectProcessingPacks;
